import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/single.css";
import Chart from "../../components/chart/Chart";
import List from "../../components/table/Table";
import { userDetails } from "../../redux/slices/userSlice";
import CenterModal from "../../components/modals/CenterModal";
import LoadingBox from "../../components/LoadingBox";
import MessageBox from "../../components/MessageBox";
import { listOrders } from "../../redux/slices/orderSlice";
import avatar from "../../assets/hacker.png";

const SingleUser = () => {
  const { error, loading, user } = useSelector((state) => state.singleUser);
  const {
    orders,
    loading: ordersLoading,
    error: ordersError,
  } = useSelector((state) => state.listOrders);

  const dispatch = useDispatch();
  const { userId } = useParams();
  useEffect(() => {
    dispatch(userDetails(userId));
    dispatch(listOrders());
  }, [dispatch, userId]);

  const allOrders = orders?.map((order) => {
    return order;
  });
  const myOrder = allOrders?.filter((order) => {
    return order?.user?.email === user?.email;
  });

  return (
    <div className="single">
      {error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <div className="singleContainer">
          <div className="top">
            <div className="left">
              <Link to={`/users/${userId}/edit`} className="editButton">
                Edit
              </Link>
              <h1 className="title">Information</h1>
              <div className="item">
                <img src={avatar} alt="user" className="itemImg" />
                <div className="details">
                  <h1 className="itemTitle">
                    {user.name} {user.lastName}
                  </h1>
                  <div className="detailItem">
                    <span className="itemKey">Email:</span>
                    <span className="itemValue">{user.email}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Phone:</span>
                    <span className="itemValue">{user.phone}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Created on:</span>
                    <span className="itemValue">{user.createdAt}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Gender:</span>
                    <span className="itemValue">{user.gender}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Is Admin:</span>
                    <span className="itemValue">
                      {user.isAdmin ? "YES" : "NO"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
            </div>
          </div>
          <div className="bottom">
            <h1 className="title">All Transactions: {myOrder?.length}</h1>
            <List myOrder={myOrder} />
          </div>
        </div>
      )}
      {loading && (
        <CenterModal
          modalHandler={loading}
          className="bg-transparent text-white"
        >
          <LoadingBox />
        </CenterModal>
      )}
    </div>
  );
};

export default SingleUser;
